import React, {Fragment} from 'react';

import {DebouncedInput} from 'app/general/primitives/DebouncedInput';
import {gt} from 'app/utils/i18n';

import type {StepEditFieldProps} from '../commonprops';

export function StepEditTextareaField({
  label,
  onChange,
  optionsButton,
}: StepEditFieldProps) {
  return (
    <Fragment>
      <div className="input-group">
        <DebouncedInput
          className="form-control"
          type="text"
          value={label}
          onChange={onChange}
          placeholder={gt('Field label...')}
        />
        {optionsButton}
      </div>
      <div className="input-group">
        <textarea
          className="form-control text-black-50"
          disabled
          value={gt('Field value is entered here')}
        />
      </div>
    </Fragment>
  );
}
